window.addEventListener('load', () => {
	let about = document.querySelector('.about'),
		img = document.querySelector('.about-img'),
		timeout;

	function resize() {
		if (timeout) {
			clearTimeout(timeout);
		}
		img.style.height = about.clientHeight + 'px';
		timeout = setTimeout(() => {
			img.style.height = about.clientHeight + 'px';	
		}, 200);
	}

	window.addEventListener('resize', resize);
	setTimeout(() => {
		resize();	
	}, .5e3);
});